// Бутонът „Експорт в Excel" — общ за всички справки.
//
// Два варианта: по подразбиране носи собствена лента с горна черта (стои ПОД
// таблицата, както е в заварените справки), а с `bare` е само бутонът — за
// тулбара на споделената таблица, където обвивката рисуваше паразитна черта
// вътре в лентата и правеше бутона по-висок от съседния „Колони".
//
// Hover ефектите са с `hover:`, не с `onMouseEnter`: JS hover „залепва" на
// телефон (класическият бъг с −/+ бутоните).

import { useState } from "react";
import { DownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

type Props = {
  onExport: () => void | Promise<void>;
  disabled?: boolean;
  /** Само бутонът, без лентата с горна черта — за тулбар. */
  bare?: boolean;
};

export default function ExportExcelButton({
  onExport,
  disabled,
  bare = false,
}: Props) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const isOff = busy || disabled;

  const handleClick = async () => {
    if (isOff) return;
    try {
      setBusy(true);
      await onExport();
    } catch (e) {
      console.error("Excel export error:", e);
    } finally {
      setBusy(false);
    }
  };

  const button = (
    <button
      type="button"
      onClick={handleClick}
      disabled={isOff}
      className={`inline-flex h-9 items-center gap-2 rounded-lg border px-3.5 text-[12.5px] font-semibold tracking-[0.2px] transition-colors ${
        isOff
          ? "cursor-not-allowed border-shade-2 bg-fill text-body"
          : "border-brand-tint2 bg-brand-tint text-brand-deep-ink hover:border-brand hover:bg-brand hover:text-white"
      }`}
    >
      {busy ? (
        <>
          <LoadingOutlined className="text-[13px]" />
          <span>{t("reportsPage.exportPreparing")}</span>
        </>
      ) : (
        <>
          <DownloadOutlined className="text-[13px]" />
          <span>{t("reportsPage.exportExcel")}</span>
        </>
      )}
    </button>
  );

  if (bare) return button;

  return (
    <div className="flex justify-end border-t border-shade-2 bg-surface px-4 py-3">
      {button}
    </div>
  );
}
